<style scoped>
.iframe-lti {
  min-height: 640px;
}
.display-inline {
  display: inline;
}
</style>

<template>
  <div>
    <form id="ltiLaunchForm" name="ltiLaunchForm" method="POST" :action="ltiUrl" class="display-inline;" ref="formLti" target="iframe">
      <input type="hidden" :name="index" v-model="launchDataSorted[index]" v-for="(item, index) in launchDataSorted" :key="index">
    </form>
    <iframe name="iframe" class="iframe-lti full-width" frameBorder="0"/>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'LTIForm',
  props: {
    service: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      launchData: {},
    }
  },
  computed: {
    launchDataSorted() {
      const ordered = {};
      Object.keys(this.launchData).forEach((key) => {
        ordered[key] = this.launchData[key];
      });
      return ordered;
    },
    ltiUrl() {
      return this.$store.state.lti.turnitin.url;
    },
    formLti() {
      return this.$refs.formLti;
    },
  },
  mounted() {
    this.fetchLti();
    if(this.formLti.addEventListener){
      this.formLti.addEventListener("submit", this.onSubmitForm, false);  // Modern browsers
    } else if(this.formLti.attachEvent){
      this.formLti.attachEvent('onsubmit', this.onSubmitForm); // IE
    }
  },
  methods: {
    // Fetch
    fetchLti() {
      axios.post(this.$store.getters.urlApi + "lti/" + this.service, this.data, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(response => {
        this.launchData = response.data.data.params
        this.$nextTick(() => {
          this.formLti.submit();
        })
      });
    },

    // Event
    onSubmitForm(e) {
      e.preventDefault();
      this.formLti.submit();
      this.fetchLti();
    },
  },
}

</script>
